import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./headers/Header";
import SideBar from "./sidebar/SideBar";

const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location?.pathname]);

  return (
    <div className="flex justify-end">
        <SideBar />
        <div className="lg:w-9/12 duration-300 ease-linear mb-8 w-full">
          <Header />
          <Outlet />
        </div>
    </div>
  );
};

export default Layout;
